import { axiosProvider, unwrapResponseData } from '@/app/core/axios';
import { getProductRouterPath } from '@/app/features/products/utils';
import { Program } from '@ssar-app/domain';

export const getProgram = async (programId: string): Promise<Program> => {
  const response = await axiosProvider.apiClient.get(
    `/program/${encodeURIComponent(
      getProductRouterPath(),
    )}?programId=${programId}`,
  );
  return unwrapResponseData(response.data);
};
